import React from 'react';
import cn from 'classnames';
import Header from 'components/Header';
import Headroom from 'react-headroom';

import section1Styles from './Home_section1.module.scss';
import section2Styles from './Home_section2.module.scss';
import section3Styles from './Home_section3.module.scss';
import section4Styles from './Home_section4.module.scss';
import section5Styles from './Home_section5.module.scss';
import section6Styles from './Home_section6.module.scss';
import styles from './Home.module.scss';

function renderSection1(props) {
  return (
    <section className={section1Styles.section1}>
      <h1 className={section1Styles.hero_title_box}>
        <span className={section1Styles.hero_title}>
          <span className={section1Styles.hero_title_span0}>Supercharge Your Career </span>
          <span className={section1Styles.hero_title_span1}>
            <br />
          </span>
          <span className={section1Styles.hero_title_span2}>with the </span>
          <span className={section1Styles.hero_title_span3}>Ultimate Resume</span>
          <span className={section1Styles.hero_title_span4}> </span>
          <span className={section1Styles.hero_title_span5}>
            <br />
          </span>
          <span className={section1Styles.hero_title_span6}>powered by AI</span>
        </span>
      </h1>

      <div className={section1Styles.flex_row}>
        <div className={section1Styles.flex_row__cell}>
          <button onClick={() => window.open('/Create', '_self')} className={section1Styles.btn}>
            <span className={section1Styles.btn__text}>Try For Free</span>
          </button>
        </div>
        <div className={section1Styles.flex_row__spacer} />
        <div className={section1Styles.flex_row__cell1}>
          <div onClick={() => window.open('#LearnMore', '_self')} className={section1Styles.content_box1}>
            <div className={section1Styles.box3} />
            <h5 className={section1Styles.highlights1}>Learn More</h5>
          </div>
        </div>
      </div>

      <div className={section1Styles.section1__cell}>
        <img
          src={require('assets/d3a9fdd62acdb2978d2cebacfea69eb5.png')}
          alt="alt text"
          className={section1Styles.image1}
        />
      </div>
    </section>
  );
}

function renderSection2(props) {
  return (
    <section className={section2Styles.section2}>
      <div className={section2Styles.section21}>
        <div className={section2Styles.flex_col}>
          <h1 id="LearnMore" className={section2Styles.hero_title1}>FEATURES</h1>
          <h3 className={section2Styles.subtitle_box}>
            <span className={section2Styles.subtitle}>
              <span className={section2Styles.subtitle_span0}>Supercharge your professional profile</span>
              <span className={section2Styles.subtitle_span1}>
                {' '}
                and captivate recruiters with our cutting-edge platform. <br />
                Maximize your chances of success by creating a{' '}
              </span>
              <span className={section2Styles.subtitle_span2}>standout profile</span>
              <span className={section2Styles.subtitle_span3}>
                {' '}
                that highlights your skills, experience, and achievements.
              </span>
            </span>
          </h3>
          <div className={section2Styles.flex_col__cell}>
            <img
              src={require('assets/b0ebeb4ff1c371b395232dd13ff07819.png')}
              alt="alt text"
              className={section2Styles.image2}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function renderSection3(props) {
  return (
    <section className={section3Styles.section3}>
      <div className={section3Styles.flex_col}>
        <h1 className={section3Styles.hero_title1}>Products</h1>
        <h3 className={section3Styles.subtitle1}>
          Experience the unlimited potential of our Premium Tier or begin your ascent <br />
          with the Freemium Tier to propel your profile to new heights.
        </h3>

        <div className={section3Styles.flex_row}>
          <div className={section3Styles.flex_row__cell}>
            <div className={section3Styles.content_box4}>
              <div className={section3Styles.flex_col1}>
                <h3 className={section3Styles.subtitle2}>Free</h3>
                <h5 className={section3Styles.highlights3}>
                  Basic profile creation
                  <br />
                  Limited profile views
                  <br />
                  AI chatbot interaction
                  <br />
                  Privacy protection
                  <br />
                  Get started for free
                </h5>

                <div onClick={() => window.open('/Create', '_self')} className={section3Styles.content_box2}>
                  <h5 className={section3Styles.highlights4}>Start Today</h5>
                </div>

                <div className={section3Styles.flex_col1__cell}>
                  <img
                    src={require('assets/7dd19196ecb76e348496c27c23cebe3e.png')}
                    alt="alt text"
                    className={section3Styles.image3}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={section3Styles.flex_row__spacer} />
          <div className={section3Styles.flex_row__cell}>
            <div className={section3Styles.content_box5}>
              <div className={section3Styles.flex_col2}>
                <h3 className={section3Styles.subtitle2}>Pro</h3>
                <h5 className={section3Styles.highlights31}>
                  All the free plan
                  <br />
                  Unlimited Profile Views
                  <br />
                  Advanced Search and Filtering
                  <br />
                  Insights into Candidate Interactions
                  <br />
                  Priority Support
                </h5>

                <div onClick={() => window.open('/Create', '_self')} className={section3Styles.content_box21}>
                  <h5 className={section3Styles.highlights4}>Start Today</h5>
                </div>

                <div className={section3Styles.flex_col2__cell}>
                  <img
                    src={require('assets/45894d709a0d6f4b062e54f9f8500e4c.png')}
                    alt="alt text"
                    className={section3Styles.image4}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function renderSection4(props) {
  return (
    <section className={section4Styles.section4}>
      <div className={section4Styles.section41}>
        <div className={section4Styles.flex_col}>
          <h1 className={section4Styles.hero_title1}>Partners</h1>
          <h3 className={section4Styles.subtitle1}>
            Join the growing list of trusted businesses that have placed their confidence in us
          </h3>

          <div className={section4Styles.flex_row}>
            <div className={section4Styles.flex_row__cell}>
              <img
                src={require('assets/5ec31feb73907e4ecf1097b06870eb33.png')}
                alt="alt text"
                className={section4Styles.icon}
              />
            </div>
            <div className={section4Styles.flex_row__spacer} />
            <div className={section4Styles.flex_row__cell}>
              <img
                src={require('assets/0711d8e20b294907f23950e215aeb29e.png')}
                alt="alt text"
                className={section4Styles.icon1}
              />
            </div>
            <div className={section4Styles.flex_row__spacer} />
            <div className={section4Styles.flex_row__cell}>
              <img
                src={require('assets/781e3941d4f0d7419598f33c653a8e47.png')}
                alt="alt text"
                className={section4Styles.image5}
              />
            </div>
            <div className={section4Styles.flex_row__spacer1} />
            <div className={section4Styles.flex_row__cell1}>
              <img
                src={require('assets/31c365fcc470b4398a6408f5b8e74b9e.png')}
                alt="alt text"
                className={section4Styles.image6}
              />
            </div>
            <div className={section4Styles.flex_row__spacer} />
            <div className={section4Styles.flex_row__cell}>
              <img
                src={require('assets/a1981f47beb80175e45c235896f67154.png')}
                alt="alt text"
                className={section4Styles.image7}
              />
            </div>
            <div className={section4Styles.flex_row__spacer} />
            <div className={section4Styles.flex_row__cell2}>
              <img
                src={require('assets/f7edc3ad932d897c0ac7edc09f209260.png')}
                alt="alt text"
                className={section4Styles.image8}
              />
            </div>
          </div>

          <div onClick={() => window.open('/AboutUs', '_self')} className={section4Styles.content_box6}>
            <div className={section4Styles.box10} />
            <h5 className={section4Styles.highlights1}>All Partners</h5>
          </div>
        </div>
      </div>
    </section>
  );
}

function renderSection5(props) {
  return (
    <section className={section5Styles.section5}>
      <div className={section5Styles.section51}>
        <div className={section5Styles.flex_col}>
          <h1 className={section5Styles.hero_title1}>Testimonials</h1>

          <div className={section5Styles.grid}>
            <div className={section5Styles.grid__cell}>
              <div className={section5Styles.flex_col1}>
                <div className={section5Styles.flex_row}>
                  <div className={section5Styles.flex_row__cell}>
                    <img
                      src={require('assets/f83bbe2dcf96c3afa3e9ecd04124263f.png')}
                      alt="alt text"
                      className={section5Styles.icon2}
                    />
                  </div>
                  <div className={section5Styles.flex_row__spacer} />

                  <div className={section5Styles.flex_col2}>
                    <h5 className={section5Styles.highlights}>Claire Bell</h5>
                    <h5 className={section5Styles.highlights1}>Designer</h5>
                  </div>
                </div>

                <h5 className={section5Styles.highlights2}>
                  Thanks to Talenter, I landed the best job of my life! Their platform provided a comprehensive space to
                  showcase all my work and achievements, making <br />
                  {`me stand out to recruiters. I couldn't be happier `}
                  <br />
                  with the opportunities it has brought me.
                </h5>
              </div>
            </div>
            <div className={section5Styles.grid__cell}>
              <div className={section5Styles.flex_col1}>
                <div className={section5Styles.flex_row}>
                  <div className={section5Styles.flex_row__cell1}>
                    <img
                      src={require('assets/d582b23da99094d0d526a64a72ea5757.png')}
                      alt="alt text"
                      className={section5Styles.icon2}
                    />
                  </div>
                  <div className={section5Styles.flex_row__spacer1} />

                  <div className={section5Styles.flex_col3}>
                    <h5 className={section5Styles.highlights}>Francisco Lane</h5>
                    <h5 className={section5Styles.highlights3}>HR</h5>
                  </div>
                </div>

                <h5 className={section5Styles.highlights2}>
                  Talenter truly transformed my job search experience. With their platform, I had all my work and
                  success consolidated in one place, allowing me to present <br />
                  my skills and accomplishments seamlessly. It played <br />a crucial role in helping me secure my dream
                  job.
                </h5>
              </div>
            </div>
            <div className={section5Styles.grid__cell}>
              <div className={section5Styles.flex_col1}>
                <div className={section5Styles.flex_row}>
                  <div className={section5Styles.flex_row__cell2}>
                    <img
                      src={require('assets/4cefa9a492d95e2713a20833eab70c02.png')}
                      alt="alt text"
                      className={section5Styles.icon2}
                    />
                  </div>
                  <div className={section5Styles.flex_row__spacer2} />

                  <div className={section5Styles.flex_col4}>
                    <h5 className={section5Styles.highlights}>Ralph Fisher</h5>
                    <h5 className={section5Styles.highlights4}>Marketer</h5>
                  </div>
                </div>

                <h5 className={section5Styles.highlights2}>
                  Finding the perfect job became a breeze with Talenter. Their platform enabled me to showcase <br />
                  my complete professional journey, including all my projects and successes. It provided a competitive
                  edge that helped me land a fantastic opportunity <br />
                  in a highly competitive field
                </h5>
              </div>
            </div>
            <div className={section5Styles.grid__cell}>
              <div className={section5Styles.flex_col1}>
                <div className={section5Styles.flex_row}>
                  <div className={section5Styles.flex_row__cell3}>
                    <img
                      src={require('assets/8a22d322bb19c2d4b9e6cb4a8492a9a5.png')}
                      alt="alt text"
                      className={section5Styles.icon2}
                    />
                  </div>
                  <div className={section5Styles.flex_row__spacer3} />

                  <div className={section5Styles.flex_col5}>
                    <h5 className={section5Styles.highlights}>Jorge Murphy</h5>
                    <h5 className={section5Styles.highlights5}>Engineer</h5>
                  </div>
                </div>

                <h5 className={section5Styles.highlights2}>
                  Talenter revolutionized how I presented myself to potential employers. Their platform gave me the
                  confidence to display my expertise and track record in one cohesive profile. It undoubtedly played a
                  significant role in securing multiple job offers, allowing me to choose the best fit for my career.
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function renderSection6(props) {
  return (
    <section id="ContactUs" className={section6Styles.section6}>
      <div className={section6Styles.flex_col}>
        <div className={section6Styles.flex_row}>
          <div className={section6Styles.flex_row__cell}>
            <img
              src={require('assets/c592f16bf2b135bb5a03643693b29ddf.png')}
              alt="alt text"
              className={section6Styles.icon3}
            />
          </div>
          <div className={section6Styles.flex_row__cell1}>
            <h5 className={section6Styles.highlights}>44 E 3rd Ave, San Mateo, CA 94401</h5>
          </div>
        </div>

        <div className={section6Styles.flex_row1}>
          <div className={section6Styles.flex_row1__cell}>
            <img
              src={require('assets/65b17410060bbaa3f9c4ae9745f1ca17.png')}
              alt="alt text"
              className={section6Styles.icon4}
            />
          </div>
          <h5 className={section6Styles.highlights1}>(650) 427-9813</h5>
        </div>

        <div className={section6Styles.flex_row2}>
          <div className={section6Styles.flex_row2__cell}>
            <img
              src={require('assets/358cc33d1ee730124c627c4b7d859815.png')}
              alt="alt text"
              className={section6Styles.icon5}
            />
          </div>
          <div className={section6Styles.flex_row2__spacer} />
          <div className={section6Styles.flex_row2__cell1}>
            <img
              src={require('assets/9da93c49fd24f114f3da6bcbb49461aa.png')}
              alt="alt text"
              className={section6Styles.icon6}
            />
          </div>
          <div className={section6Styles.flex_row2__spacer} />
          <div className={section6Styles.flex_row2__cell1}>
            <img
              src={require('assets/8c87398acd1c1a9d1603a0f5896e16a4.png')}
              alt="alt text"
              className={section6Styles.icon6}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default function Home(props) {
  return (
    <React.Fragment>
      <Headroom tag="header" className="page-header">
        <nav className="max:show">
          <Header />
        </nav>
      </Headroom>

      <main className={cn(styles.main, 'home')}>
        <div className={styles.main__cell}>{renderSection1(props)}</div>
        <div className={styles.main__cell}>{renderSection2(props)}</div>
        <div className={styles.main__cell}>{renderSection3(props)}</div>
        <div className={styles.main__cell}>{renderSection4(props)}</div>
        <div className={styles.main__cell}>{renderSection5(props)}</div>
        <div className={styles.main__cell}>{renderSection6(props)}</div>
      </main>
    </React.Fragment>
  );
}
